:host{display:block}
/*# sourceMappingURL=past-eoc.component-EMLGG7W6.css.map */
